import { Email } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import AuthService from "src/services/authService";
import { User } from "src/services/dto/Security";
import UserService from "src/services/userService";
import { showApiError, useQuery } from "src/services/utils";
import { injectAuthUser } from "src/store/actions/auth";

import FormEngine from "@components/FormEngine/FormEngine";

import { regex } from "@utils/zod";

const handleLoginRedirect = (user: User, history: any, query: any) => {
  if (user?.setupPassword) {
    history.replace(
      `/resetPasswordPage?${[
        "step=2",
        "setup=1",
        `email=${encodeURIComponent(user.email)}`,
        `code=${user.requestToken}`,
      ].join("&")}`,
    );
  } else if (user?.requestPassword) {
    history.replace(
      `/resetPasswordPage?${["reset=1", `token=${user.requestToken}`].join(
        "&",
      )}`,
    );
  } else if (user?.needConfirm) {
    history.replace(
      `/appointment/confirmation?${[
        "view=confirm",
        `apptId=${query.get("apptId")}`,
      ].join("&")}`,
    );
  } else if (user?.confirmDetails) {
    history.replace("/confirm-details");
  } else {
    const aptId = query.get("aptId") as string;
    if (aptId) {
      UserService.getAppointment(aptId).then((aptRsp) => {
        history.replace(
          aptRsp.data.patientId === user.id
            ? `/waitingRoomPage?apt=${aptId}`
            : "/patientDashboardPage",
        );
      });
    } else if (query.get("insuranceRedirect")) {
      if (
        /iPhone/i.test(navigator.userAgent) ||
        /Android/i.test(navigator.userAgent)
      ) {
        history.replace("/upload-insurance?v=1");
      } else {
        history.replace("/profile?step=insurance");
      }
    } else if (query.get("paperwork")) {
      history.replace(
        `/registration?step=${user?.onboardingProgress || "provider"}`,
      );
    } else if (query.get("ouraRedirect")) {
      history.replace("/profile?step=oura");
    } else {
      history.replace("/patientDashboardPage");
    }
  }
};

const LoginForm = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const query = useQuery();
  const email = useQuery().get("email");

  // click Continue
  const clickContinue = (values: { email: string; password: string }) => {
    let obj: any = { email: values.email, password: values.password };
    if (query.get("apptflg")) {
      obj.checkAppointmentId = query.get("apptflg");
    }
    AuthService.cleanAuth();
    AuthService.login(obj)
      .then((rsp) => {
        const user = rsp.data.user as User;
        AuthService.saveAuth(rsp.data);
        dispatch(injectAuthUser(user));
        handleLoginRedirect(user, history, query);
      })
      .catch((e) => {
        showApiError(e);
      });
  };

  return (
    <FormEngine
      submitBtnTitle="Login"
      cancelBtnTitle="Forgot Password"
      format={{
        buttonsDirection: "row-reverse",
        spacing: 1,
      }}
      data={{ email: email || "", password: "" }}
      submitBtnProps={{
        sx: { width: "fit-content", px: 2 },
      }}
      cancelBtnProps={{
        sx: { width: "fit-content", px: 2 },
      }}
      onSubmit={clickContinue}
      onCancel={() => history.push("/resetPasswordPage")}
      schema={[
        {
          name: "email",
          label: "Email Address",
          type: "input",
          rule: regex.email,
          icon: <Email />,
        },
        {
          name: "password",
          label: "Password",
          type: "password",
        },
      ]}
    />
  );
};

export default LoginForm;
